import React from 'react'

import { BaseView } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface SkeletonListTemplateProps {
  sizeList?: number
  containerStyles?: React.CSSProperties
  itemWidth?: number | string
  itemHeight?: number
  itemRadius?: number
  paddingList?: number
  showItemBackground?: boolean
  itemMarginBottom?: boolean
  containerGap?: number
}

export const SkeletonListTemplate: React.FC<SkeletonListTemplateProps> = ({
  sizeList = 3,
  containerStyles,
  itemWidth = 350, // Default width for web
  itemHeight = 76,
  itemRadius = 24,
  paddingList = 12,
  showItemBackground = false,
  itemMarginBottom = false,
  containerGap = 12,
}) => {
  const theme = useTheme()

  const SkeletonBox: React.FC<{
    width: string | number
    height: string | number
    borderRadius?: string | number
  }> = ({ width, height, borderRadius = '4px' }) => (
    <BaseView
      style={{
        width,
        height,
        backgroundColor:
          theme.colors.skeleton?.backgroundColor ||
          theme.colors.background.secondaryGray + '40',
        borderRadius,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <BaseView
        style={{
          position: 'absolute',
          top: 0,
          left: '-100%',
          width: '100%',
          height: '100%',
          background: `linear-gradient(90deg, transparent, ${theme.colors.skeleton?.foregroundColor || 'rgba(255,255,255,0.1)'}, transparent)`,
          animation: 'skeleton-shimmer 1.5s infinite',
        }}
      />
    </BaseView>
  )

  return (
    <BaseView gap={containerGap} style={containerStyles}>
      <style>
        {`
          @keyframes skeleton-shimmer {
            0% { left: -100%; }
            100% { left: 100%; }
          }
        `}
      </style>

      {Array.from({ length: sizeList }).map((_, index) => (
        <BaseView
          key={index}
          className={itemMarginBottom ? 'mb-2' : ''}
          bgColor={showItemBackground ? 'background.cardItemRoot' : undefined}
          style={{
            width: itemWidth,
            height: itemHeight,
            borderRadius: itemRadius,
            padding: paddingList,
            backgroundColor: showItemBackground ? undefined : 'transparent',
          }}
        >
          <SkeletonBox width="100%" height="100%" borderRadius={itemRadius} />
        </BaseView>
      ))}
    </BaseView>
  )
}
